import { render, staticRenderFns } from "./CardGrid.vue?vue&type=template&id=12b7af72&"
import script from "./CardGrid.vue?vue&type=script&lang=ts&"
export * from "./CardGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CardGrid.vue?vue&type=style&index=0&id=12b7af72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports